import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper as MuiPaper, Skeleton } from '@mui/material';
import { styled } from '../../utils';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
export function Notice({ type, onClick, children, icon, loading, ariaKeyShortcuts, }) {
    const selectedIcon = icon ||
        (type === 'error'
            ? 'close'
            : type === 'warning'
                ? 'alert'
                : type === 'success'
                    ? 'check'
                    : false);
    return (_jsxs(PaperStyled, { onClick: onClick, type: loading ? 'neutral' : type, clickable: Boolean(onClick), "aria-keyshortcuts": ariaKeyShortcuts, children: [loading ? (_jsx(Skeleton, { variant: "text", animation: "wave", children: _jsx(Typography, { variant: "subtitle2", children: children }) })) : (_jsx(Typography, { variant: "subtitle2", children: children })), selectedIcon &&
                (loading ? (_jsx(Skeleton, { variant: "circular" })) : (_jsx(Icon, { variant: selectedIcon, fontSize: "small" })))] }));
}
const PaperStyled = styled(MuiPaper, {
    shouldForwardProp: (prop) => prop !== 'clickable',
})(({ theme, clickable, type }) => ({
    whiteSpace: 'pre-line',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2, 3, 2),
    [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(4),
    ...(clickable && {
        cursor: 'pointer',
    }),
    ...(type === 'error' && {
        '& .MuiIcon-root': {
            color: theme.palette.error.main,
        },
        border: `2px solid ${theme.palette.error.main}`,
    }),
    ...(type === 'success' && {
        '& .MuiIcon-root': {
            color: theme.palette.success.main,
        },
        border: `2px solid ${theme.palette.success.main}`,
    }),
    ...(type === 'warning' && {
        '& .MuiIcon-root': {
            color: theme.palette.warning.main,
        },
        border: `2px solid ${theme.palette.warning.main}`,
    }),
}));
